import React, { useState, useContext } from "react";
import Lang from "../../components/Lang";
import DrawStoppedStudent from "./DrawStoppedStudent";

import { ClassesContext } from "../../../../Context";

import Loading from "../../Loading";
import StudentsLostAtLocation from "./StudentsLostAtLocation";
import useDB from "../../hooks/useDB";
import Error from "../../components/Error";
import SelectFromList from "../../components/SelectFromList";
import useCTX from "../../hooks/useCTX";

export default function LostStudents({ month, year }) {
  const { findClasses } = useContext(ClassesContext)
  const [stopped, setStopped, error, loading] = useDB(
    `/stopped-students/${year}/${month}`
  );
  const [filter, setFilter] = useState("")
  const { center } = useCTX()

  if(loading) return <Loading />
  if(error) return <Error />





  let reasons = [];
  for (const s of stopped) {
    for (const r of s.stoppedReasons) {
      if(!reasons.includes(r)) reasons.push(r)
    }
  }

  console.log(reasons)
return (
  <div>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {/*  <h3>
      Lost students in <Month value={month+1} /> ({stopped.length})
      </h3> */}
      <StudentsLostAtLocation students={stopped} />
      <SelectFromList
        choices={center.stoppedReasons.filter(r=>reasons.includes(r._id)).map(r=>({_id:r._id, name: `${r.name} (${stopped.filter(s=>s.stoppedReasons.includes(r._id)).length})`}))}
        value={filter}
        setValue={setFilter}
        label={<Lang w="filter" />}
        none
        size="small"
        style={{width:300}}
      />
      
    </div>
    <div
      style={{ display: "flex" }}
      className="new-lost-students-table-title"
    >
      <div style={{ width: 300, minWidth: 300 }}>
        <Lang w="name" />
      </div>
      <div style={{ width: 200 }}>
        <Lang w="status" />
      </div>
      <div style={{ width: 150 }}>
        <Lang w="dateTheyStopped" />
      </div>
      <div style={{ flexGrow: 1 }}></div>
    </div>

    {stopped
      .filter((s) => (filter ? s.stoppedReasons.includes(filter) : true))
      .map((student) => (
        <DrawStoppedStudent
          student={student}
          setStopped={setStopped}
          key={student._id}
        />
      ))}
  </div>
);
}
